export default {
  methods: {
    objToDate(obj) {
      if (!obj) {
        return null;
      }

      return new Date(
        Date.UTC(
          obj.year,
          obj.month - 1,
          obj.day,
          (obj.hour || 0) + (obj.utcOffset || 0),
          obj.minute || 0
        )
      );
    },
  },
};
